var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:(`border-radius: 4px;background-color: ${_vm.accentColor};padding:5px;width:30px;height:30px;`)},[_c('v-img',{staticStyle:{"margin-top":"5px"},attrs:{"src":require("../assets/handle.png")}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }